import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import BaseButton from 'base-components/BaseButton/BaseButton';
import { useEffect, useRef, useState } from 'react';
import { Accordion, AccordionBody, AccordionHeader, AccordionItem, List } from 'reactstrap';
import './Toast.scss';

type UploadErrorHeaders = {
    value: string;
    index: number;
};
export type UploadErrorRecord = {
    recNum: number;
    column: string | null;
    value: string | null;
    errText: string;
    headers: UploadErrorHeaders[] | null;
};

export type ToastData = {
    id: string;
    type: 'success' | 'danger' | 'info' | 'warning';
    title?: string;
    description?: string;
    icon: IconDefinition;
    progress?: number;
    data?: UploadErrorRecord[] | null;
    autoDeleteTime?: number;
};

export type ToastProps = ToastData & {
    deleteToast: () => void;
};

const Toast = ({
    id,
    type,
    title,
    description,
    icon,
    progress,
    data,
    autoDeleteTime,
    deleteToast,
}: ToastProps) => {
    const [open, setOpen] = useState('');
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        let interval: NodeJS.Timer;
        if (autoDeleteTime) {
            interval = setInterval(() => {
                deleteToast();
            }, autoDeleteTime);
        }

        return () => {
            clearInterval(interval);
        };
    }, [autoDeleteTime]);

    const toggle = (id: string) => {
        setOpen(open === id ? '' : id);
    };

    const accordionProps = { toggle: toggle };
    const className = 'notification';
    return (
        <div
            ref={ref}
            className={`${className} bottom-right ${className}-${type.toLowerCase()} ${
                data && data.length && open !== '' ? 'notifyCollapced' : ''
            }`}
        >
            <BaseButton className={className + '__button-close'} onClick={() => deleteToast()}>
                X
            </BaseButton>
            <div className={className + '__icon'}>
                <FontAwesomeIcon icon={icon} size="1x" pull="right" />
            </div>
            {title && (
                <div className={className + '__title mb-2'}>
                    <span>{title}</span>
                </div>
            )}
            {description && (
                <div className={className + '__message custom-scrollbar'}>
                    <span>{description}</span>
                </div>
            )}
            {!!progress && (
                <div className="mt-1">
                    <div className="progress">
                        <div
                            className="progress-bar progress-bar-info"
                            role="progressbar"
                            aria-valuenow={progress}
                            aria-valuemin={0}
                            aria-valuemax={100}
                            style={{ width: progress + '%' }}
                        >
                            {progress}%
                        </div>
                    </div>
                </div>
            )}
            {data && data.length > 0 && (
                <div className="mt-2">
                    <div className={className + '__message custom-scrollbar'}>
                        <Accordion flush open={open} {...accordionProps}>
                            <AccordionItem>
                                <AccordionHeader
                                    style={{
                                        color: 'black !important',
                                        marginRight: '5px',
                                    }}
                                    targetId={id.toString()}
                                >
                                    {data.length.toString()}
                                </AccordionHeader>
                                <AccordionBody accordionId={id.toString()}>
                                    <List type="unstyled">
                                        {data.map((item, w) => (
                                            <li key={w} style={{ whiteSpace: 'inherit' }}>
                                                {item.column ? (
                                                    <>
                                                        {item.recNum
                                                            ? `${item.recNum} ,`
                                                            : undefined}
                                                        {item.column}:{' '}
                                                        {item.errText}
                                                        {` ${item.value}`}
                                                        <List type="unstyled">
                                                            {item.headers?.map((x, i) => (
                                                                <li
                                                                    key={i}
                                                                >{`${x.index} : ${x.value}`}</li>
                                                            ))}
                                                        </List>
                                                    </>
                                                ) : (
                                                    item.errText.toString()
                                                )}
                                            </li>
                                        ))}
                                    </List>
                                </AccordionBody>
                            </AccordionItem>
                        </Accordion>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Toast;
